import { createFileRoute, redirect } from '@tanstack/react-router'

import { getToken, isTwoFactorInProgress } from "@/lib/token/token";
import { OtpForm } from "@/modules/login/components/otp-form";

export const Route = createFileRoute('/two-factor')({
  beforeLoad: (): void => {
    if (!isTwoFactorInProgress()) {
      throw redirect({to: '/login'})
    }

    if (getToken() && !isTwoFactorInProgress()) {
      throw redirect({to: '/'})
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-[#022D4F]">
      <OtpForm />
    </div>
  )
}
